module.exports = __webpack_public_path__ + "static/media/clayton-soares.52063b87.png";